import React from 'react';
import { useTranslation } from 'react-i18next';
import Heading from 'components/Heading';
import Card from 'components/Card';
import Panel from 'components/Panel';
import EmptyStateController from 'components/EmptyStateController';
import useUniqueId from 'hooks/useUniqueId';
import { useFetchMyCalendarSettings } from './hooks/useFetchMyCalendarSettings';
import CalendarDisconnectedContent from './CalendarDisconnectedContent';
import CalendarLinkedContent from './CalendarLinkedContent';
import CalendarDeAuthorisedContent from './CalendarDeAuthorisedContent';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function UserCalendarIntegration() {
  var _data$hasAccountLinke, _data$hasActiveSubscr;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var titleId = useUniqueId();
  var _useFetchMyCalendarSe = useFetchMyCalendarSettings(),
    data = _useFetchMyCalendarSe.data,
    isLoading = _useFetchMyCalendarSe.isLoading,
    isError = _useFetchMyCalendarSe.isError;
  var hasAccountLinked = (_data$hasAccountLinke = data === null || data === void 0 ? void 0 : data.hasAccountLinked) !== null && _data$hasAccountLinke !== void 0 ? _data$hasAccountLinke : false;
  var hasActiveSubscription = (_data$hasActiveSubscr = data === null || data === void 0 ? void 0 : data.hasActiveSubscription) !== null && _data$hasActiveSubscr !== void 0 ? _data$hasActiveSubscr : false;
  return /*#__PURE__*/_jsx(Card, {
    role: "region",
    "aria-labelledby": titleId,
    children: /*#__PURE__*/_jsxs(Panel, {
      children: [/*#__PURE__*/_jsx(Heading, {
        as: "h2",
        mb: "s",
        id: titleId,
        children: t('auto_join_settings_title')
      }), /*#__PURE__*/_jsxs(EmptyStateController, {
        isLoading: isLoading,
        isError: isError,
        isEmpty: !data,
        data: data,
        children: [!hasAccountLinked && /*#__PURE__*/_jsx(CalendarDisconnectedContent, {}), hasAccountLinked && hasActiveSubscription && data && /*#__PURE__*/_jsx(CalendarLinkedContent, {
          settings: data
        }), hasAccountLinked && !hasActiveSubscription && data && /*#__PURE__*/_jsx(CalendarDeAuthorisedContent, {
          settings: data
        })]
      })]
    })
  });
}
export default UserCalendarIntegration;